var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(5308 -232)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 32,
    height: 32,
    transform: "translate(-5308 232)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Github",
    d: "M9.99,21.549C4.283,23.261,4.283,18.7,2,18.125m15.98,6.848V20.556h0a3.847,3.847,0,0,0-1.073-2.979c3.584-.4,7.351-1.758,7.351-7.99h0a6.209,6.209,0,0,0-1.711-4.281h0a5.787,5.787,0,0,0-.1-4.3S21.1.6,17.98,2.693h0a15.272,15.272,0,0,0-7.99,0C6.874.6,5.527,1,5.527,1h0a5.787,5.787,0,0,0-.1,4.3h0A6.209,6.209,0,0,0,3.712,9.621c0,6.186,3.767,7.545,7.351,7.99h0A3.847,3.847,0,0,0,9.99,20.556v4.417",
    transform: "translate(-5305.5 235.527)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.eb2521fb039b0c3a6259a41f1c8c84be.svg";
export { ForwardRef as ReactComponent };